import React, { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiButton from '@mui/material/Button';
import { CustomSelect } from '../../../../../ui/custom_react_select/custom_select';
import { TextInput } from '../../../../../ui/input/text_input/text_input';
import { UserGroup, UserRole } from '../../../../../utils/types/admin_types';
import { SelectOptions } from '../../../../../utils/types/react_select_types';

type EditGroupModalProps = {
  group: UserGroup;
  userRoleList: UserRole[];
  editGroup: (
    group: UserGroup,
    groupName: string,
    roleList: SelectOptions[]
  ) => void;
};

export const EditGroupModal = ({
  group,
  userRoleList,
  editGroup,
}: EditGroupModalProps) => {
  const [groupName, setGroupName] = useState<string>(group.groupName);
  const [selectedRoles, setSelectedRoles] = useState(() =>
    group?.roles.map((role) => ({
      value: role.id,
      label: role.roleName,
    })),
  );

  const roleOptions = useMemo(
    () =>
      userRoleList.map((role) => ({
        value: role.id,
        label: role.roleName,
      })),
    [userRoleList],
  );

  const handleRoleChange = (selectedOptions: SelectOptions[]) => {
    setSelectedRoles(selectedOptions);
  };

  return (
    <Stack spacing={3} sx={{ width: '100%', pt: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, width: { xs: '100%', sm: '80%' } }}>
        <TextInput
          name='groupName'
          value={groupName}
          type='text'
          label='Group Name'
          onChange={(event) => setGroupName(event.target.value)}
        />
        <CustomSelect
          name='roles'
          options={roleOptions}
          onChange={handleRoleChange}
          isMulti={true}
          label='Role Membership'
          value={selectedRoles}
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <MuiButton
          onClick={() => editGroup(group, groupName, selectedRoles)}
          variant='contained'
          sx={{
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 600,
            bgcolor: '#093725',
            '&:hover': { bgcolor: '#062619' },
          }}
        >
          Edit groups
        </MuiButton>
      </Box>
    </Stack>
  );
};
